"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Validator;

var React = _interopRequireWildcard(require("react"));

var PropTypes = _interopRequireWildcard(require("prop-types"));

var _onestoreBem = _interopRequireDefault(require("@homepl/onestore-bem"));

var _ValidatorItem = _interopRequireDefault(require("../../shapes/ValidatorItem"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

var mValidator = (0, _onestoreBem.default)("m-validator");

function Validator(_ref) {
  var items = _ref.items;
  return React.createElement("ul", {
    className: mValidator().toString()
  }, items.map(function (item, key) {
    return React.createElement("li", {
      key: key,
      className: mValidator("item").has({
        success: item.status === "success",
        error: item.status === "error"
      }).toString()
    }, item.label);
  }));
}

Validator.propTypes = {
  items: PropTypes.arrayOf(_ValidatorItem.default)
};
Validator.defaultProps = {
  items: []
};